window.addEventListener("load", function () {
  document
    .querySelectorAll(".variant-picker__option-values input")
    .forEach((input) => {
      input.addEventListener("focus", function (event) {
        event.preventDefault();
        // Adicione o comportamento desejado aqui, se necessário
      });
    });
  console.log("pagina carrega");
});

document.addEventListener("DOMContentLoaded", function () {
  // Listener global para capturar todos os eventos de foco
  document.addEventListener(
    "focus",
    function (event) {
      console.log("Focus event on:", event.target);
      event.preventDefault();
    },
    true
  ); // O terceiro parâmetro `true` ativa o modo de captura
});

document.addEventListener("DOMContentLoaded", function () {
  let lastScrollPosition = window.scrollY;

  // Listener global para capturar todos os eventos de foco
  document.addEventListener(
    "focus",
    function (event) {
      if (event.target.matches(".variant-picker__option-values input")) {
        console.log("Focus event on:", event.target);
        event.preventDefault();

        // Forçar a rolagem de volta para a posição anterior
        window.scrollTo(0, lastScrollPosition);
      }
    },
    true
  );

  // Atualizar a posição de rolagem sempre que a página rolar
  window.addEventListener("scroll", function () {
    lastScrollPosition = window.scrollY;
  });
});

document.addEventListener("DOMContentLoaded", function () {
  function removeExtraDrawers() {
    console.log("removeExtraDrawers");

    setTimeout(() => {
      const drawers = document.querySelectorAll("x-drawer");
      if (drawers.length > 0) {
        for (let i = 1; i < drawers.length; i++) {
          drawers[i].remove();
        }
      }
    }, 100);
  }
  document.querySelectorAll(".size-chart-button").forEach((button) => {
    button.addEventListener("click", function (event) {
      removeExtraDrawers();
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // EUA URL
  var url = window.location.href;
  var urlsplit = url.split("?")[0];
  if (urlsplit == "https://weasypet.com/") {
    var divs = document.querySelectorAll('div[reveal-on-scroll="true"]');
    for (var i = 0; i < divs.length; i++) {
      var imgs = divs[i].querySelectorAll("img");
      for (var j = 0; j < imgs.length; j++) {
        imgs[j].addEventListener("click", function () {
          window.location.href = "https://weasypet.com/products/weasy-for-dogs";
        });
      }
    }

    var divs = document.querySelectorAll(
      'div.media-with-text__media[reveal-on-scroll="true"]'
    );

    for (var i = 0; i < divs.length; i++) {
      divs[i].addEventListener("click", function () {
        window.location.href = "https://weasypet.com/products/weasy-for-dogs";
      });
    }

    var imageBanners = document.querySelectorAll("image-banner");

    for (var i = 0; i < imageBanners.length; i++) {
      var imgs = imageBanners[i].querySelectorAll("img");
      for (var j = 0; j < imgs.length; j++) {
        imgs[j].addEventListener("click", function () {
          window.location.href = "https://weasypet.com/products/weasy-for-dogs";
        });
      }
    }

    var divs2 = document.querySelectorAll(".media-with-text__item");
    // adicionar a classe 'weasy-card' a cada div
    for (var i = 0; i < divs2.length; i++) {
      divs2[i].classList.add("weasy-card");
    }
    console.log("pagina inicial eua");
  }

  // en-ca URL
  if (urlsplit == "https://weasypet.com/en-ca") {
    var divs = document.querySelectorAll('div[reveal-on-scroll="true"]');
    for (var i = 0; i < divs.length; i++) {
      var imgs = divs[i].querySelectorAll("img");
      for (var j = 0; j < imgs.length; j++) {
        imgs[j].addEventListener("click", function () {
          window.location.href =
            "https://weasypet.com/en-ca/products/weasy-for-dogs";
        });
      }
    }

    var divs = document.querySelectorAll(
      'div.media-with-text__media[reveal-on-scroll="true"]'
    );

    for (var i = 0; i < divs.length; i++) {
      divs[i].addEventListener("click", function () {
        window.location.href =
          "https://weasypet.com/en-ca/products/weasy-for-dogs";
      });
    }

    var imageBanners = document.querySelectorAll("image-banner");

    for (var i = 0; i < imageBanners.length; i++) {
      var imgs = imageBanners[i].querySelectorAll("img");
      for (var j = 0; j < imgs.length; j++) {
        imgs[j].addEventListener("click", function () {
          window.location.href =
            "https://weasypet.com/en-ca/products/weasy-for-dogs";
        });
      }
    }

    var divs2 = document.querySelectorAll(".media-with-text__item");
    // adicionar a classe 'weasy-card' a cada div
    for (var i = 0; i < divs2.length; i++) {
      divs2[i].classList.add("weasy-card");
    }
    console.log("pagina inicial en-ca");
  }

  // en-gb URL
  if (urlsplit == "https://weasypet.com/en-gb") {
    var divs = document.querySelectorAll('div[reveal-on-scroll="true"]');
    for (var i = 0; i < divs.length; i++) {
      var imgs = divs[i].querySelectorAll("img");
      for (var j = 0; j < imgs.length; j++) {
        imgs[j].addEventListener("click", function () {
          window.location.href =
            "https://weasypet.com/en-gb/products/weasy-for-dogs";
        });
      }
    }

    var divs = document.querySelectorAll(
      'div.media-with-text__media[reveal-on-scroll="true"]'
    );

    for (var i = 0; i < divs.length; i++) {
      divs[i].addEventListener("click", function () {
        window.location.href =
          "https://weasypet.com/en-gb/products/weasy-for-dogs";
      });
    }

    var imageBanners = document.querySelectorAll("image-banner");

    for (var i = 0; i < imageBanners.length; i++) {
      var imgs = imageBanners[i].querySelectorAll("img");
      for (var j = 0; j < imgs.length; j++) {
        imgs[j].addEventListener("click", function () {
          window.location.href =
            "https://weasypet.com/en-gb/products/weasy-for-dogs";
        });
      }
    }

    var divs2 = document.querySelectorAll(".media-with-text__item");
    // adicionar a classe 'weasy-card' a cada div
    for (var i = 0; i < divs2.length; i++) {
      divs2[i].classList.add("weasy-card");
    }
    console.log("pagina inicial en-gb");
  }
});
